import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import logo from '../../assets/logo.svg'
import React from 'react'
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Close } from '@mui/icons-material';
import ContactModal from '../ContactModal/ContactModal'
import { Link } from 'react-router-dom'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));



const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 2, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};


const NavBar = () => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <Navbar fixed="top" collapseOnSelect expand="lg" bg="white" className="shadow-sm py-3">
                <Container>
                    <Link to="/" data-aos="fade-down"
                        data-aos-easing="linear"><img height="100%" width="100%" src={logo} alt="bluecoder_logo" loading="eager" title="Bluecoder Logo" /></Link>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="mx-auto me-0 pe-0 d-flex flex-wrap">
                            <Link className="links m-1 text-primary border border-info px-3 py-1 rounded-pill" to="/"
                                data-aos="fade-up"
                                data-aos-easing="linear">Home</Link>
                            <Link className="links m-1 text-primary border border-info px-3 py-1 rounded-pill" to="about"
                                data-aos="fade-up"
                                data-aos-easing="linear"
                                data-aos-delay="200">About Us</Link>
                            <Link className="links m-1 text-primary border border-info px-3 py-1 rounded-pill" to="services"
                                data-aos="fade-up"
                                data-aos-easing="linear"
                                data-aos-delay="300">Services</Link>
                            {/* <Link className="links m-1 text-primary border border-info px-3  py-1 rounded-pill" to="pricing"
                                data-aos="fade-up"
                                data-aos-easing="linear"
                                data-aos-delay="400">Pricing</Link> */}
                            <Link className="links m-1 text-primary border border-info px-3  py-1 rounded-pill" to="contact"
                                data-aos="fade-up"
                                data-aos-easing="linear"
                                data-aos-delay="500">Contact</Link>
                            <Button className="m-1 text-white border border-info px-3 py-1 rounded-pill" id="login_btn" to="/" variant="primary" onClick={handleClickOpen}
                                data-aos="zoom-in"
                                data-aos-easing="linear"
                                data-aos-delay="600">Get Quote</Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} />
                <DialogContent>
                    <ContactModal />
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}

export default NavBar